<template>
<div>
    <v-alert text prominent dense type="error" v-if="mensaje">
        {{mensaje}}
    </v-alert>
    <v-card class="pa-2 " color="grey lighten-2" outlined tile v-else>
        <v-container>
            <v-row justify="space-around">
                <v-col cols="12" sm="12" md="12" style="min-heigth:80px" v-for="(item, i) in certificados" :key="i">
                    <v-sheet min-height="100%" width="100%">
                        <v-container fluid class="pa-0">
                            <v-row align="center" no-gutters class="text-center" style="min-height:80px">

                                <v-col cols="12" sm="12" md="12">
                                    <p>
                                        {{item.ciceCertificado}}
                                    </p>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</div>
</template>

<script>

export default {
    props: {
        certificados: Array,
    },
    data() {
        return {
            mensaje: null,
        };
    },
    created: async function () {
         if (this.certificados.length == 0) {
            this.mensaje = "No se ah registrado ningun certificado"
        }
    }
};
</script>

<style>

</style>
